import {
    MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE,
    MEDSTAR_ASSOCIATION_TYPE__UNKNOWN,
    MEDSTAR_ASSOCIATION_TYPE__VENDOR,
    MEDSTAR_ASSOCIATION_TYPE__STUDENT,
    MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR,
    MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER,
    MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER
} from '../../sitel/commons/utilities/medstarAssociationType';

export function titleText(medstarAssociationType) {
    switch (medstarAssociationType) {
        case MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE:
            return {
                title: "New MedStar Health Employee",
                mutedTitle: "For MedStar Health New Hire"
            };
        case MEDSTAR_ASSOCIATION_TYPE__UNKNOWN:
        case MEDSTAR_ASSOCIATION_TYPE__VENDOR:
        case MEDSTAR_ASSOCIATION_TYPE__STUDENT:
        case MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR:
        case MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER:
        case MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER:
            return {
                title: "Non-MedStar Health Employees",
                mutedTitle: "For contractors, vendors, students, and other non-MedStar Health-employed individuals"
            };
        default:
            return false;
    }
}
